import "./index.css";
import SubHeaderBox from "../../components/SubHeaderBox";
import { useTranslation } from "react-i18next";
import ProdLossesTable from "./Table";
import { ShowHideTable } from "../../components/ShowHideTable";
import { usePDFShowHide } from "../../../../../hooks/usePDFShowHide";
import TableLoadingWrapper from "../../../../../components/TableLoadingWrapper";

const ProdLossesContents = ({ productId }) => {
  const { t } = useTranslation();
  const [showTable, setShowTable, isPDFMode] = usePDFShowHide(false, {
    pdfDelay: 5000,
    forceShowInPDF: true,
  });
  const shouldShowTable = isPDFMode || showTable;

  return (
    <div className="prod-component-contents">
      <SubHeaderBox
        subTitle={t("LOSSES_CATEGORY")}
        subDescription={t("LOSSES_CATEGORY_DESC")}
        isNormal={true}
        number={"31.5"}
      />

      {shouldShowTable && (
        <TableLoadingWrapper
          tableId={`prod-losses-lca-${productId}`}
          minLoadTime={3000}
          maxLoadTime={20000}
        >
          <ProdLossesTable productId={productId} />
        </TableLoadingWrapper>
      )}
      <ShowHideTable showTable={showTable} setShowTable={setShowTable} />
    </div>
  );
};

export default ProdLossesContents;

